import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs';
import { UserScopesService } from '../services/user-scopes.service';

export const hasScopesGuard =
  (requiredScopes: readonly string[]): CanActivateFn =>
  () => {
    const router = inject(Router);

    return inject(UserScopesService)
      .hasScopes(requiredScopes)
      .pipe(
        map((hasRequiredScopes) =>
          hasRequiredScopes ? true : router.parseUrl('/error/403'),
        ),
      );
  };
